import { useState, useEffect } from 'react';
import { ContentWrapper, Textbox } from 'components/generic';
import Images from 'assets/Images';
import { cloneDeep } from 'lodash';
import { useFetch } from 'hooks';
import './style.scss';

const BasicDetails = props => {
	const { onSave } = props;
	const [editbutton, setEditButton] = useState(false);
	const [profileLogo, setProfileLogo] = useState();
	const [createObj, setCreateObj] = useState({});
	const [originalObj, setOriginalObj] = useState({});
	const api = useFetch();

	const handleData = (e, key) => {
		key === 'profilePhoto' && setImage(e);
		setCreateObj(prevState => {
			const data = cloneDeep(prevState);
			data[key] = e;
			return data;
		});
	};

	const updateUser = async () => {
		const form = new FormData();
		Object.keys(createObj)?.forEach(el => {
			form.append(el, el === 'attributes' ? JSON.stringify(createObj[el]) : createObj[el]);
		});
		await api({ url: 'client/v1/editUserDetails', method: 'post', data: form, successToaster: true });
		await userDetails();
		onSave();
		return;
	};

	const userDetails = async () => {
		const { data } = await api({ url: 'client/v1/userDetails', method: 'get' });
		data?.data && localStorage.setItem('_ud', JSON.stringify(data?.data));
	};

	const handleButtonClick = async key => {
		key === 'cancel' && setCreateObj(cloneDeep(originalObj));
		key === 'save' && updateUser();
		setEditButton(prevState => !prevState);
	};

	const setImage = e => {
		const img = e && URL.createObjectURL(e);
		setProfileLogo(img);
	};

	useEffect(() => {
		const { firstName, lastName, attributes, email } = localStorage.getItem('_ud') && JSON.parse(localStorage.getItem('_ud'));
		const obj = { firstName, lastName, attributes, mobileNumber: attributes?.MOBILE?.at(), email, profilePhoto: attributes?.profilePhoto?.at() };
		setCreateObj(obj);
		setOriginalObj(cloneDeep(obj));
		setProfileLogo(attributes?.profilePhoto?.at());
	}, []);

	return (
		<>
			<ContentWrapper shadow>
				<div className='basic-details'>
					<div className='space-between'>
						<h4>Basic Details</h4>
						{!editbutton && (
							<div className='basic-details__button align-center' onClick={() => setEditButton(prevState => !prevState)}>
								<img src={Images['edit-blue']} /> Edit
							</div>
						)}
					</div>
					<div className='row basic-details__container'>
						<div className='basic-details__profile column-center'>
							<img className='basic-details__logo' src={!['undefined', 'null', undefined, null]?.includes(profileLogo) ? profileLogo : Images.user} alt='User' />
							<p>Profile Photo</p>
							{editbutton && (
								<div className='basic-details__logo-edit'>
									<input type='file' accept='.png, .jpeg, .jpg' onChange={e => handleData(e.target.files[0], 'profilePhoto')} />
									<label>Change Photo</label>
								</div>
							)}
						</div>
						<div className='col-9 basic-details__content'>
							<div className='row'>
								<div className='col-6'>
									<Textbox label='First Name' mandatory display={!editbutton} placeholder='Enter' value={createObj?.firstName} onChange={e => handleData(e?.target?.value, 'firstName')} />
								</div>
								<div className='col-6'>
									<Textbox label='Last Name' mandatory placeholder='Enter' display={!editbutton} value={createObj?.lastName} onChange={e => handleData(e?.target?.value, 'lastName')} />
								</div>
								<div className='col-6'>
									<Textbox label='Work Email' disabled display={!editbutton} value={createObj?.email} onChange={e => handleData(e?.target?.value, 'email')} />
								</div>
								<div className='col-6'>
									<Textbox label='Mobile Number' type='text' mandatory placeholder='Enter' display={!editbutton} value={createObj?.mobileNumber} onChange={e => handleData(e?.target?.value, 'mobileNumber')} />
								</div>
							</div>
						</div>
					</div>
					{editbutton && (
						<div className='flex-end'>
							<div className='basic-details__button--cancel' onClick={() => handleButtonClick('cancel')}>
								Cancel
							</div>
							<div className='basic-details__button align-center' onClick={() => handleButtonClick('save')}>
								Save
							</div>
						</div>
					)}
				</div>
			</ContentWrapper>
		</>
	);
};

export default BasicDetails;
